import { IconButton } from '@bnnvara/buttons/src/components/IconButton/styled';
import { Text as BaseText } from '@bnnvara/typography';
import styled from 'styled-components';

export const Button = styled(IconButton)`
  display: flex;
  align-items: center;

  svg {
    color: ${({ isBookmarked, theme }) =>
      isBookmarked ? theme.primary.main : theme.base.black};
  }

  div {
    margin-left: ${({ size }) => (size === 's' ? '0.2rem' : '0.5rem')};
  }
`;

export const Text = styled(BaseText)`
  font-size: ${({ size }) => (size === 's' ? '13px' : undefined)};
`;
